import { Currency } from '@uniswap/sdk-core'
import { DEFAULT_FALLBACK_CHAIN, SupportedChainId } from 'constants/chains'
import useHttpLocations from 'hooks/useHttpLocations'
import { useMemo } from 'react'
import { WrappedTokenInfo } from 'state/lists/wrappedTokenInfo'

import EthereumLogo from '../../assets/images/ethereum-logo.png'
import EvmosLogo from '../../assets/images/evmos-logo.png'

type Network = 'ethereum' | 'evmos' | 'evmos_testnet' | 'rinkeby'

function chainIdToNetworkName(networkId: SupportedChainId): Network {
  switch (networkId) {
    case SupportedChainId.MAINNET:
      return 'evmos'
    case SupportedChainId.EVMOS_TESTNET:
      return 'evmos_testnet'
    case SupportedChainId.RINKEBY:
      return 'rinkeby'
    default:
      return 'ethereum'
  }
}

function getNativeLogoURI(chainId: SupportedChainId = DEFAULT_FALLBACK_CHAIN): string {
  switch (chainId) {
    case SupportedChainId.MAINNET:
    case SupportedChainId.EVMOS_TESTNET:
    case SupportedChainId.RINKEBY:
      return EvmosLogo
    default:
      return EthereumLogo
  }
}

function getTokenLogoURI(address: string, chainId: SupportedChainId = DEFAULT_FALLBACK_CHAIN): string | void {
  const networkName = chainIdToNetworkName(chainId)
  const networksWithUrls = [SupportedChainId.MAINNET, SupportedChainId.EVMOS_TESTNET, SupportedChainId.RINKEBY]
  if (networksWithUrls.includes(chainId)) {
    return `https://raw.githubusercontent.com/cronus-finance/token-list/main/assets/${networkName}/${address}/logo.png`
  }
}

export default function useCurrencyLogoURIs(currency?: Currency | null): string[] {
  const locations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)
  return useMemo(() => {
    const logoURIs = [...locations]
    if (currency) {
      if (currency.isNative) {
        logoURIs.push(getNativeLogoURI(currency.chainId))
      } else if (currency.isToken) {
        const logoURI = getTokenLogoURI(currency.address, currency.chainId)
        if (logoURI) {
          logoURIs.push(logoURI)
        }
      }
    }
    return logoURIs
  }, [currency, locations])
}
